import { render, staticRenderFns } from "./RequestWorksSimpleSection.vue?vue&type=template&id=748e8858&scoped=true&"
import script from "./RequestWorksSimpleSection.vue?vue&type=script&lang=js&"
export * from "./RequestWorksSimpleSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748e8858",
  null
  
)

export default component.exports